import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

interface DownloadButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

export const DownloadButtonEcho: React.FC<DownloadButtonProps> = ({
  onClick,
  disabled = false,
  label = 'Download',
}) => {
  return (
    <Button
      type="primary"
      icon={<DownloadOutlined aria-hidden="true" />}
      size="large"
      onClick={onClick}
      disabled={disabled}
      data-testid="download-button"
    >
      {label}
    </Button>
  );
};
